function vertical_slider_height(slider_rows_obj, start_row, finish_row) {
  var new_slider_height = 0;
  for (let j = start_row; j <= finish_row; j++) {
    new_slider_height = Number(new_slider_height) + Number(slider_rows_obj[j]);
  }
  new_slider_height = new_slider_height + 52;
  return new_slider_height;
}

function vertivalSliderScroll(e) {
  if (e.target.classList.contains('carousel_vert-button')) {
    var slider = e.target.closest('.display-type--carousel_vert').querySelector('.products.carousel_vert');
    var current_row = Number(slider.getAttribute('data-current-row'));
    var next_row = current_row + 1;
    var prev_row = current_row - 1;
    var slider_rows = Number(slider.getAttribute('data-slider-rows'));
    var total_rows = Number(slider.getAttribute('data-total-rows'));
    var slides_per_row = Number(slider.getAttribute('data-slides-per-row'));

    var slider_rows_obj = {}
    for (let i = 1; i <= total_rows; i++) {
      var first_slide_in_row = (i - 1) * slides_per_row + 1;
      var row_height = slider.querySelector('.columns:nth-child(' + first_slide_in_row + ')').offsetHeight;
      slider_rows_obj[i] = row_height;
    }

    if (e.target.classList.contains('next') && (current_row + slider_rows - 1) < total_rows) {
      var slider_translate = 0;
      for (let i = 1; i <= current_row; i++) {
        slider_translate = slider_translate + slider_rows_obj[i];
      }
      slider_translate = slider_translate * -1;
      slider.style.translate = '0 ' + slider_translate + 'px';
      var start_row = next_row;
      var finish_row = start_row + slider_rows - 1;
      var new_slider_height = vertical_slider_height(slider_rows_obj, start_row, finish_row);
      slider.closest('.display-type--carousel_vert').style.height = new_slider_height + 'px';
      slider.setAttribute('data-current-row',next_row);
    }

    if (e.target.classList.contains('previous') && current_row > 1) {
      var slider_translate = 0;
      for (let i = 1; i < current_row - 1; i++) {
        slider_translate = slider_translate + slider_rows_obj[i];
      }
      slider_translate = slider_translate * -1;
      slider.style.translate = '0 ' + slider_translate + 'px';
      var new_slider_height = 0;
      var start_row = prev_row;
      var finish_row = start_row + slider_rows - 1;
      var new_slider_height = vertical_slider_height(slider_rows_obj, start_row, finish_row);
      slider.closest('.display-type--carousel_vert').style.height = new_slider_height + 'px';
      slider.setAttribute('data-current-row',prev_row);
    }
  }
}
document.addEventListener('click',vertivalSliderScroll);

function vertical_slider(slider){
  slider.setAttribute('data-current-row',1);
  if (slider.hasAttribute('style')) {
    slider.removeAttribute('style');
  }
  var slide_width = Number(slider.querySelector('.columns:first-child').offsetWidth);
  var slider_width = Number(slider.offsetWidth);
  var slider_rows = Number(slider.getAttribute('data-rows'));
  var total_slides = slider.querySelectorAll('.columns').length;
  var slides_per_row = Math.round(slider_width / slide_width);
  var total_rows = Math.ceil(total_slides / slides_per_row);

  var slider_rows_obj = {}
  for (let i = 1; i <= total_rows; i++) {
    var first_slide_in_row = (i - 1) * slides_per_row + 1;
    var row_height = slider.querySelector('.columns:nth-child(' + first_slide_in_row + ')').offsetHeight;
    slider_rows_obj[i] = row_height;
  }

  var slider_height = 0;
  for (let j = 1; j <= slider_rows; j++) {
    slider_height = slider_height + slider_rows_obj[j];
  }
  slider_height = slider_height + 52;

  slider.setAttribute('data-current-row',1);
  slider.setAttribute('data-slider-rows',slider_rows);
  slider.setAttribute('data-total-rows',total_rows);
  slider.setAttribute('data-slides-per-row',slides_per_row);

  if (total_rows > slider_rows) {
    if (!slider.closest('.display-type--carousel_vert').querySelector('.flickity-button')) {
      var button = document.createElement('button');
      button.classList.add('flickity-button','carousel_vert-button');
      var button_prev = button.cloneNode();
      var button_next = button.cloneNode();
      button_prev.classList.add('previous');
      button_next.classList.add('next');

      slider.closest('.display-type--carousel_vert').prepend(button_prev);
      slider.closest('.display-type--carousel_vert').append(button_next);
    }
    slider.classList.add('vertical-slider-active');
    slider.closest('.display-type--carousel_vert').style.height = slider_height + 'px';
  } else {
    if (slider.classList.contains('vertical-slider-active')) {
      slider.classList.remove('vertical-slider-active');
    }
    slider.closest('.display-type--carousel_vert').style.height = 'auto';
  }
}

document.addEventListener('DOMContentLoaded',()=>{
  if (document.querySelector('.display-type--carousel_vert .products.carousel_vert')) {
    document.querySelectorAll('.display-type--carousel_vert .products.carousel_vert').forEach((slider)=>{
      vertical_slider(slider);
      window.addEventListener('resize', ()=>{
        vertical_slider(slider);
      });
    });
  }
});